import { useCallback } from 'react';

import { dropUserBulk } from 'src/api/user';

import { useSnackbar } from 'src/components/snackbar';

export const useDropUserBulk = () => {
  const { enqueueSnackbar } = useSnackbar();

  const deleteUserBulk = useCallback(
    async (ids, user) => {
      try {
        await dropUserBulk(ids, user.id);
        enqueueSnackbar('Delete success!', { variant: 'success' });
        return { success: true, error: null };
      } catch (error) {
        enqueueSnackbar(`Deletion failed: ${error.message}`, { variant: 'error' });
        return { success: false, error };
      }
    },
    [enqueueSnackbar]
  );

  return { deleteUserBulk };
};
